var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CRow',[_c('CCol',{attrs:{"sm":"12"}},[_c('CrmReports',{attrs:{"title":"CRM Reports","standalone":"","group-by-day":"","show-link-filter":"","show-user-filter":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }